document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[id^="lbp-"]').forEach(function (wrapper) {
    var swiperEl = wrapper.querySelector('.lbp-swiper');
    var prevEl = wrapper.querySelector('.lbp-prev');
    var nextEl = wrapper.querySelector('.lbp-next');
    var paginationEl = wrapper.querySelector('.lbp-pagination');

    if (!swiperEl || typeof Swiper === 'undefined') return;

    new Swiper(swiperEl, {
      slidesPerView: 1.5,
      spaceBetween: 14,
      centeredSlides: false,
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl
      },
      breakpoints: {
        900: {
          slidesPerView: 4,
          spaceBetween: 20,
          centeredSlides: false
        }
      }
    });
  });
});